import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    name: { label: i18n.t('app.name'), value: '' },
    tipoDistribuidor: { label: i18n.t('distributors.tipo_distribuidor'), value: '' },
    tipoProvisionamiento: { label: i18n.t('distributors.tipo_provisionamiento'), value: '' },
  } 
}
const columns = function getColumns () {
  return [
    { field: 'IdDistribuidor', width: '100px', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    { field: 'Nombre', width: '240px', title: i18n.t('app.name'), columnMenu: 'myTemplate', locked: false },
    { field: 'NumeroClientes', width: '200px', title: i18n.t('license.num_clients'), format: 'integer', cell: 'numberTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'idTipoDistribuidor', width: '300px', title: i18n.t('distributors.tipo_distribuidor'), format: 'TIPOS_DISTRIBUIDOR', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'idTipoProvisionamiento', width: '300px', title: i18n.t('distributors.tipo_provisionamiento'), format: 'TIPOS_DISTRIBUIDOR_PROVISIONAMIENTO', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'PermiteWizard', width: '450px', minResizableWidth: 225, title: i18n.t('clients.permite_wizard'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
  ] 
}
const mystore = parent({ selectable: true, navigate: true, namespaced: true, getTranslateColumns: columns, getTranslateMasterFilters })

export default mystore
